<template>
  <v-chip v-if="enabled" outlined color="primary" :class="float">
    <v-icon small left> mdi-star-outline </v-icon>Advanced</v-chip
  >
</template>

<script>
export default {
  props: {
    feature: {
      type: Object,
      default: Object,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    enabled: {
      type: Boolean,
      default: Boolean,
    },
    floatDirection: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    float() {
      return {
        [`float-${this.floatDirection}`]: ["left", "right"].includes(
          this.floatDirection
        ),
      };
    },
  },
  methods: {},
};
</script>

<style></style>
